<template>
    <tr>
        <td>
            {{ scan_action_prototype.barcode }}
        </td>
        <td>
            <barcode
                :value="scan_action_prototype.barcode"
                :tag="'svg'"
                :options="{
                    background: 'transparent',
                    displayValue: true,
                    format: 'CODE128',
                    width: 1,
                    height: 25
                }">
                看見此資訊請通知系統工程師。
            </barcode>
        </td>
        <td>
            {{ scan_action_prototype.name }}
        </td>
        <td>
            <router-link
                v-if="false"
                :to="{name: 'scan_action_prototype', params: {identity: scan_action_prototype.identity}}"
                class="ui basic primary button">
                {{ $t('ui.general.detail') }}
            </router-link>
            <router-link
                :to="{name: 'edit_scan_action_prototype', params: {identity: scan_action_prototype.identity}}"
                class="ui basic positive button">
                {{ $t('ui.general.edit') }}
            </router-link>
        </td>
    </tr>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'

export default {
    name: "ProviderScanActionPrototypesIndexItem",
    props: {
        scan_action_prototype: Object
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
        env() {
            return ENV.NODE_ENV
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        human_time(time) {
            return this.$moment(time).locale("zh-tw").format("lll")
        }
    },
    components: {
        'barcode': VueBarcode
    }
}
</script>
